export default __webpack_public_path__ + "static/media/201.31c59677.jpg";